export const getRequiresAppointment = (
  isDaycare?: boolean | null,
  canRegularlyAttendDaycare?: boolean | null
): boolean => {
  return !isDaycare || (isDaycare && !canRegularlyAttendDaycare);
};
